import { getDefaultFavoriteTreeData } from '../store/getDefaultFavoriteTreeData';
import { setFavoriteTreeData } from '../mutators/setFavoriteTreeData';
import favoritesStore from '../store/store';

export function initializeFavoriteTreeData(mailboxInfoKey: string) {
    if (!favoritesStore.favoriteTreeData.has(mailboxInfoKey)) {
        setFavoriteTreeData(mailboxInfoKey, getDefaultFavoriteTreeData(mailboxInfoKey));
    }
}
